import React from 'react';
import Input from 'blocks/Input';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';

@withRouter
@inject('alert')
export default class PasswordRecovery extends React.Component {

  state = { form: { password_confirmation: '', password: ''}, errors: {} };

  handleChange = e => {
    let newState = _.assign({}, this.state.form, e);
    this.setState({form: newState} );
  };

  submit = e => {
    e.preventDefault();
    let errors = validate(this.state.form, VALIDATION_CONSTRAINTS);
    if(errors) {
      this.setState({errors: errors});
      return;
    }
    new HttpClient().post('/api/v1/users/update_password',
      _.assign({}, this.state.form, {token: this.props.match.params.token})).then(() => {
        this.props.alert.success('Password successfully updated');
        this.props.history.push('/newuser/signin');
        }
    )
  };

  render(){
    return(
      <div className="row justify-content-center align-items-center sign-up-form-holder">
        <div className="col-12 col-md-10">
          <form onSubmit={this.submit}>
            <div className="row">
              <div className="col">
                <h1 className="sign-up-title">Set New Password</h1>
                <p className="sign-up-greeting">
                  Enter your new password below</p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Input name="password"
                       type="password"
                       value={this.state.form.password}
                       handleChange={this.handleChange}
                       placeholder="Set New Password"
                        error={this.state.errors.password}/>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <Input name="password_confirmation"
                       type="password"
                       value={this.state.form.password_confirmation}
                       handleChange={this.handleChange}
                       placeholder="Repeat New Password"
                       error={this.state.errors.password_confirmation}/>
              </div>
            </div>

            <div className="btn-holder">
              <button type="submit" className="btn blue empty bordered">Set new Password</button>
            </div>
            <div className="forgot-holder">
            </div>
          </form>
        </div>
      </div>
    )
  }
}




const VALIDATION_CONSTRAINTS = {
  password_confirmation: {
    equality: {
      attribute: 'password',
      message: 'needs to be the same as the new password specified'
    }
  },

  password: {
    length: {
      minimum: 6,
      tooShort: 'must be minimum 6 characters'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/new_user/PasswordRecovery.jsx